import DataQuery from "data/DataQuery";
import {
  Customer_ContractDropdown,
  Customer_ContractualAccounts,
} from "data/endpoints";
import { useQuery } from "data/hooks/useQuery";
import ConditionalExecute from "data/models/ConditionalExecute";
import ContractDropdownDTO from "features/contracts/dtos/ContractDropdownDTO";
import ContractualAccountDTO from "features/contracts/dtos/ContractualAccountDTO";
import PagedDataResultDTO from "features/shared/dtos/PagedDataResultDTO";
import { getContractualAccountsParams } from "features/shared/helpers/queryParams";
import { getRouteParams } from "features/shared/helpers/routeParams";

export const useAccountRestrictionsData = (
  customerId: string,
  reloadData: boolean,
  forAdminUse: boolean
): {
  contracts: ContractDropdownDTO[];
  contractualAccounts: PagedDataResultDTO<ContractualAccountDTO>;
} => {
  //#region HELPERS
  const getQueryParams = (params?: URLSearchParams): URLSearchParams => {
    let queryParams = params ? new URLSearchParams(params) : new URLSearchParams();
    
    if (forAdminUse) {
      queryParams.append("ForAdminUse", "true");      
    }
    
    return queryParams;
  };
  //#endregion HELPERS

  //#region FETCH DATA
  // conditional execute (load data for account dialog)
  const conditionalExecute: ConditionalExecute = {
    apply: true,
    condition: () => reloadData === true,
  };

  // contracts (place of deliveries)
  let contractsQuery: DataQuery = {
    url: Customer_ContractDropdown,
    routeParams: getRouteParams("customerId", customerId),
    params: getQueryParams()
  };
  const { data: contracts } = useQuery<ContractDropdownDTO[]>(
    contractsQuery,
    [],
    [customerId, reloadData],
    { useTracker: true },
    conditionalExecute
  );

  // contractual accounts
  let accountsQuery: DataQuery = {
    url: Customer_ContractualAccounts,
    routeParams: getRouteParams("customerId", customerId),
    params: getQueryParams(getContractualAccountsParams())
  };
  const { data: contractualAccounts } = useQuery<PagedDataResultDTO<ContractualAccountDTO>>(
    accountsQuery,
    { count: 0, result: [] },
    [customerId, reloadData],
    { useTracker: true },
    conditionalExecute
  );
  //#endregion FETCH DATA

  //#region RETURN
  return {
    contracts,
    contractualAccounts
  };
  //#endregion RETURN
};
